import { render, staticRenderFns } from "./SeqPrimerEditor.vue?vue&type=template&id=b74320ea&"
import script from "./SeqPrimerEditor.vue?vue&type=script&lang=js&"
export * from "./SeqPrimerEditor.vue?vue&type=script&lang=js&"
import style0 from "./SeqPrimerEditor.vue?vue&type=style&index=0&id=b74320ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports